// src/utils/cookies.js

// Cookie utility functions for session management

export const setCookie = (name, value, days = 7) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
};

export const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

export const deleteCookie = (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

// Session management
export const saveUserSession = (userId, username, sessionId) => {
    console.log('[Cookies] Saving user session:', { userId, username, sessionId: sessionId?.substring(0, 8) + '...' });
    setCookie('userId', userId, 30); // 30 days
    setCookie('username', username, 30);
    if (sessionId && sessionId !== 'undefined') {
        setCookie('sessionId', sessionId, 30);
    } else {
        console.warn('[Cookies] Invalid sessionId, not saving:', sessionId);
    }
};

export const getUserSession = () => {
    const userId = getCookie('userId');
    const username = getCookie('username');
    const sessionId = getCookie('sessionId');
    
    // Filter out 'undefined' string values
    const validSessionId = sessionId && sessionId !== 'undefined' ? sessionId : null;
    
    return userId && username ? { userId, username, sessionId: validSessionId } : null;
};

export const clearUserSession = () => {
    deleteCookie('userId');
    deleteCookie('username');
    deleteCookie('sessionId');
    // Also clear localStorage session data
    localStorage.removeItem('sessionId');
    localStorage.removeItem('sessionExpiresAt');
}; 